import axios from 'axios';
import { getAuthHeaders } from '../../auth/session';

const withAuth = (config = {}) => ({
  ...config,
  headers: {
    ...(config.headers || {}),
    ...getAuthHeaders(),
  },
});

export async function fetchList(endpoint, params = {}) {
  const { data } = await axios.get(endpoint, withAuth({ params }));
  return data;
}

export async function createItem(endpoint, payload) {
  const { data } = await axios.post(endpoint, payload, withAuth());
  return data;
}

export async function updateItem(endpoint, id, payload) {
  const { data } = await axios.put(`${endpoint}/${id}`, payload, withAuth());
  return data;
}

export async function deleteItem(endpoint, id) {
  const { data } = await axios.delete(`${endpoint}/${id}`, withAuth());
  return data;
}

export async function postAction(endpoint, payload = {}) {
  const { data } = await axios.post(endpoint, payload, withAuth());
  return data;
}

export async function fetchLookups() {
  const { data } = await axios.get('/api/construtor/lookups', withAuth());
  return data;
}
